export default __webpack_public_path__ + "static/media/hotBack.27c7d9db.png";